export const firebaseFunctionsUrl = (endpoint: string) => {
  // Always use cloud functions (no emulator)
  return import.meta.env.VITE_ENV === "LOCAL" ||
    import.meta.env.VITE_ENV === "DEV"
    ? `https://api-se7ho5yqsa-uc.a.run.app/${endpoint}`
    : `https://api-deqxfy6vga-uc.a.run.app/${endpoint}`;
};
